/**
 * @fileoverview This file defines a function to report frontend errors to the backend.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "reportErrorToServer", {
    enumerable: true,
    get: function() {
        return reportErrorToServer;
    }
});
async function reportErrorToServer(errorBody, options = {}) {
    const errorLog = {
        message: errorBody,
        source: options.source || 'default',
        errorCode: options.errorCode || '500',
        endpoint: options.endpoint || '',
        method: options.method || '',
        url: options.url || '',
        stack: options.stack || ''
    };
    try {
        const response = await fetch('/_/fe_error_log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(errorLog)
        });
        if (!response.ok) {
            console.error('Failed to send frontend error log. Status:', response.status);
        }
    } catch (e) {
        console.error(e, 'Failed to send frontend error log:', errorLog);
    }
}
